module.exports = __webpack_public_path__ + "img/SI.9a72ead6.svg";